import { fetch, fetching, fetched, errored, reset } from './user.types';

export const fetchUser = () => ({ type: fetch });
export const fetchingUser = () => ({ type: fetching });
export const fetchedUser = user => ({ type: fetched, user });
export const fetchUserError = error => ({ type: errored, error });
export const resetUser = () => ({ type: reset });
